import t from 'tcomb';

const is_color_regexp = /^#([a-f0-9]{6}|[a-f0-9]{3})$/i;

const is_color = (s) => {
  return is_color_regexp.test(s);
};

const Color = t.subtype(t.Str, is_color);

module.exports = Color;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Color.js
 **/